import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const OutfitOverviewPage = lazy(
  () =>
    import('./OutfitOverviewPage.eager').then(mod => ({
      default: mod.OutfitOverviewPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
